import { forwardRef, type Ref, type SVGProps } from "react";

function SvgMastercardColored(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        fill="#ED0006"
        fillRule="evenodd"
        d="M11.966 15.907a4.27 4.27 0 0 1-2.857 1.102c-2.432 0-4.404-2.065-4.404-4.612S6.677 7.785 9.11 7.785c1.09 0 2.088.414 2.857 1.101a4.27 4.27 0 0 1 2.856-1.101c2.432 0 4.404 2.065 4.404 4.612s-1.972 4.612-4.404 4.612a4.27 4.27 0 0 1-2.856-1.102"
        clipRule="evenodd"
      />
      <path
        fill="#F9A000"
        fillRule="evenodd"
        d="M11.965 15.907a4.7 4.7 0 0 0 1.547-3.51 4.7 4.7 0 0 0-1.547-3.51 4.27 4.27 0 0 1 2.856-1.102c2.433 0 4.404 2.065 4.404 4.612s-1.971 4.612-4.404 4.612a4.27 4.27 0 0 1-2.856-1.102"
        clipRule="evenodd"
      />
      <path
        fill="#FF5E00"
        fillRule="evenodd"
        d="M11.965 8.887a4.7 4.7 0 0 1 1.548 3.51c0 1.406-.6 2.664-1.548 3.51a4.7 4.7 0 0 1-1.547-3.51c0-1.406.6-2.664 1.547-3.51"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgMastercardColored);
export default ForwardRef;
